import { render, staticRenderFns } from "./CampaignGoalListTable.vue?vue&type=template&id=c55da928&"
import script from "./CampaignGoalListTable.vue?vue&type=script&lang=js&"
export * from "./CampaignGoalListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports